import { useSyncExternalStore } from "react";

export function isPinchZoomed(): boolean {
  return (window.visualViewport?.scale ?? 1) > 1;
}

//a changed zoom level resizes the visual viewport
function subscribe(onChange: () => void) {
  window.visualViewport?.addEventListener("resize", onChange);
  return () => window.visualViewport?.removeEventListener("resize", onChange);
}

/**
 * Whether the page is zoomed in by a pinch gesture, so the content can be panned in every direction
 * instead of being swiped.
 */
export function usePinchZoomed(): boolean {
  return useSyncExternalStore(subscribe, isPinchZoomed);
}
